exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".child-select-item .router-link-active[data-v-63476902]{color:#fff;background-color:#82ba1d!important}.child-select-item .router-link-active[data-v-63476902]:before{color:#fff!important}.child-select-area .child-select-item .btn-child[data-v-63476902]{background-color:#fff;padding-left:2rem;position:relative;white-space:normal!important;word-wrap:break-word}.child-select-area .child-select-item .btn-child[data-v-63476902]:before{font-family:FontAwesome;content:\"\\F007\";font-size:1.2rem;color:#82ba1d;position:absolute;top:50%;transform:translateY(-50%) translateX(0);left:5%}.child-select-area .child-select-item .btn-child[data-v-63476902]:hover{background-color:#72b400;color:#fff}.child-select-area .child-select-item .btn-child[data-v-63476902]:hover:before{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-63476902&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/page/partials/MyPage/ChildInfo/PageForm.vue
// module id = 518
// module chunks = 0